<template>
  <div class="lg:mr-44">
    <!-- Hero -->
    <div
      :style="[
        { background: 'url(/img/careers-expo-7.jpg)' },
        { minHeight: '500px' },
        { backgroundPosition: '50% 20%' },
      ]"
      class="hero-gradient bg-cover relative w-full flex flex-col justify-end items-center pb-12 text-white bg-no-repeat"
    >
      <h4 class="z-20 font-poppins uppercase text-expo_red">
        Book your stands
      </h4>
      <h1 class="z-20 font-bold">Exhibitor Registration</h1>
    </div>

    <!-- Content start -->
    <div
      class="bg-truegray-100 flex flex-col items-center justify-center py-24 px-3 lg:px-10"
    >
      <div class="w-full max-w-6xl bg-white rounded-xl shadow relative z-10">
        <!-- Header -->
        <div
          id="formTop"
          class="bg-expo_dblue w-full flex flex-col lg:flex-nowrap text-center items-center justify-center space-y-8 pt-12 z-10"
        >
          <img
            class="h-20 z-10 mt-8"
            src="/img/expo_symbol_white2025.png"
            alt="expo logo symbol"
          />
          <h2 class="font-questrial text-white text-center z-10 px-4">
            {{ settings.active_year }} Exhibitor Registration
          </h2>
        </div>
        <div class="w-full overflow-x-hidden relative bottom-px">
          <div class="form-header_curve bg-expo_dblue w-full"></div>
        </div>

        <!-- Step wrapper -->
        <div
          id="stepWrapper"
          class="relative transition-all duration-300 ease-in-out z-60"
        >
          <!-- Step 1 -->
          <div
            id="step-1"
            :class="
              activeStep === 1
                ? 'translate-x-0'
                : 'pointer-events-none opacity-0 absolute transform -translate-x-full'
            "
            class="inset-0 p-12 2xl:p-24 transition-opacity expo-transition duration-300 ease-in-out delay-100"
          >
            <div class="w-full pb-4 border-b border-truegray-300">
              <h5 class="text-sm m-0 font-black uppercase text-truegray-500">
                Step {{ activeStep }}
              </h5>
              <h4 class="text-expo_dblue">Book your stands</h4>
              <h5 class="text-sm m-0 text-truegray-500 italic">
                All prices listed on this page are GST exclusive
              </h5>
            </div>

            <!-- Leaving in retired discount incase of re-introduction -->
            <!--
              <div v-if="locationsBooked >= 3" class="pt-8 text-green-400 flex space-x-4">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
              </svg>
              <p class="font-bold">5% stand discount applied!</p>
              </div> 
            -->

            <div class="grid grid-cols-1 lg:grid-cols-3 gap-x-12 gap-y-2 py-8">
              <div v-for="(event, i) in storeEvents" :key="i">
                <p>{{ event.title }}</p>
                <h5 class="text-sm mb-2 font-black text-expo_red">
                  ${{ event.cost_per_stand }} each
                </h5>
                <input
                  :id="'event-' + event.id"
                  v-model="stands[i]"
                  class="placeholder-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600 flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary focus:placeholder-truegray-300 rounded-lg relative bg-white border border-truegray-300 mb-4"
                  :name="'event-' + event.id"
                  type="number"
                  min="0"
                  autocomplete="off"
                  @change="updateStands(event, i)"
                />
              </div>
            </div>
            <h5 class="text-center italic font-light">
              If you would like an online only pro listing, go straight to the
              next page
            </h5>
          </div>

          <!-- Step 2 -->
          <div
            id="step-2"
            :class="
              activeStep === 2
                ? 'translate-x-0'
                : 'pointer-events-none opacity-0 absolute transform -translate-x-full'
            "
            class="inset-0 p-12 2xl:p-24 transition-opacity expo-transition duration-300 ease-in-out delay-100"
          >
            <div class="w-full pb-4 border-b border-truegray-300">
              <h5 class="text-sm m-0 font-black uppercase text-truegray-500">
                Step {{ activeStep }}
              </h5>
              <h4 class="text-expo_dblue">Online Expo</h4>
            </div>

            <div
              class="w-full relative justify-center items-center grid grid-cols-1 lg:grid-cols-2 gap-12 py-12"
            >
              <div class="w-full flex flex-col justify-center items-start">
                <p class="font-base">
                  With a professional listing, you will get:
                </p>
                <ul class="list-disc my-6">
                  <li class="ml-8 pl-4">
                    A large premium online profile and be featured at the top of
                    our directory list
                  </li>
                  <li class="ml-8 pl-4">
                    You will be able to customise your listing with your own
                    videos, photos, logo, branding, social media links and
                    content!
                  </li>
                  <li class="ml-8 pl-4">
                    Plus, you can create 'Posts' on your profile, which will be
                    shared to the 'CareerWise Cloud' a tool used by Career
                    Advisors all around New Zealand!
                  </li>
                </ul>

                <p class="mb-4 font-base">
                  Thanks to our partnership with
                  <a href="https://careerwise.school" target="_blank"
                    >CareerWise</a
                  >, you can share your content with schools and their students
                  all year round! You also get all the statistics which show
                  your post shares and reach results. A total of 3 posts are
                  included as part of your professional listing, and you can
                  purchase more posts at anytime in the year should you wish!
                </p>

                <h5 class="text-sm m-0 font-black">
                  Get a professional listing
                </h5>
                <p class="text-xs m-0 font-base">
                  ${{ costDiscountedOnline }} for Exhibitors with at least 1
                  stand
                </p>
                <p class="text-xs mb-4 font-base">
                  ${{ costOnline }} for 'online only' Exhibitors
                </p>

                <div
                  v-if="locationsBooked > 0 && proListing"
                  class="py-2 text-green-400 flex space-x-4"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  <p class="font-bold">
                    Online exhibitor discount of ${{ discountOnline }} applied!
                  </p>
                </div>
                <div v-if="proListing" class="mt-4">
                  <p>Profile Login Email</p>
                  <span class="text-truegray-500 text-xs italic"
                    >The email used to login and manage your Professional
                    listing</span
                  >
                  <input
                    id="proEmail"
                    v-model="proEmail"
                    :class="
                      proEmailValidationError
                        ? 'border-red-300 text-red-600'
                        : 'border-truegray-300'
                    "
                    class="placeholder-truegray-300 focus:border-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600 flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary focus:placeholder-truegray-300 rounded-lg relative bg-white border mb-4"
                    name="proEmail"
                    type="email"
                    autocomplete="off"
                  />
                </div>
                <div v-show="locationsBooked > 0">
                  <div class="flex space-x-4 items-center">
                    <p>Opt out</p>
                    <input
                      id="proListing"
                      v-model="listingOptOut"
                      name="proListing"
                      type="checkbox"
                      class="focus:ring-blue-700 h-4 w-4 text-blue-900 rounded"
                    />
                  </div>
                  <p class="text-xs italic mt-2">
                    Opting out will mean you will feature as an exhibitor in our
                    Online Expo with a Basic Listing, and will be positioned
                    after the Professional Listings.
                  </p>
                </div>
              </div>

              <div class="w-full flex flex-col justify-center items-center">
                <!--
                  <div @click="videoModal = !videoModal" class="relative video-placeholder w-full max-w-xl h-60 z-10 flex justify-center items-center text-white bg-expo_dblue cursor-pointer bg-no-repeat bg-cover bg-center" :style="{ backgroundImage: 'url(/img/careers-expo-15.png'}">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-32 w-32 hover:opacity-100 opacity-75 cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clip-rule="evenodd" />
                  </svg>
                  </div> 
                -->
                <div
                  :style="[
                    {
                      backgroundImage:
                        'url(/img/careers-expo-onlinescroll.png)',
                    },
                    { minHeight: '450px' },
                  ]"
                  class="w-full onlineanimate lg:w-10/12 bg-cover flex items-center justify-center text-white rounded shadow-2xl"
                ></div>
              </div>
            </div>
          </div>

          <!-- Step 3 -->
          <div
            id="step-3"
            :class="
              activeStep === 3
                ? 'translate-x-0'
                : 'pointer-events-none opacity-0 absolute transform -translate-x-full'
            "
            class="inset-0 p-12 pb-0 2xl:p-24 transition-opacity expo-transition duration-300 ease-in-out delay-100"
          >
            <div class="w-full pb-4 border-b border-truegray-300">
              <h5 class="text-sm m-0 font-black uppercase text-truegray-500">
                Step {{ activeStep }}
              </h5>
              <h4 class="text-expo_dblue">Organisation Details</h4>
              <h5 class="text-xs m-0 text-truegray-500 italic">
                Please fill out this section with the information that could be
                used for a member of the public to contact your organisation
              </h5>
            </div>

            <div class="grid grid-cols-1 lg:grid-cols-2 gap-x-24 gap-y-4 py-8">
              <div>
                <p>
                  Organisation Name
                  <span class="text-xs text-expo_red">* </span>
                  <span class="text-truegray-500 text-xs italic">required</span>
                </p>
                <input
                  id="orgName"
                  v-model="organisation.name"
                  class="placeholder-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600 flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary focus:placeholder-truegray-300 rounded-lg relative bg-white border border-truegray-300 mb-4"
                  name="orgName"
                  type="text"
                  autocomplete="off"
                />
              </div>
              <div>
                <p>Preferred Stand Fascia Name</p>
                <input
                  id="orgPrefName"
                  v-model="organisation.pref_name"
                  class="placeholder-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600 flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary focus:placeholder-truegray-300 rounded-lg relative bg-white border border-truegray-300 mb-4"
                  name="orgPrefName"
                  type="text"
                  autocomplete="off"
                />
              </div>
              <div>
                <p>Organisation Phone</p>
                <input
                  id="orgPhone"
                  v-model="organisation.phone"
                  :class="
                    organisation.validation_error.includes('phone')
                      ? 'border-red-300 text-red-600'
                      : 'border-truegray-300'
                  "
                  class="placeholder-truegray-300 focus:border-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600 flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary focus:placeholder-truegray-300 rounded-lg relative bg-white border mb-4"
                  name="orgPhone"
                  type="tel"
                  autocomplete="off"
                />
              </div>
              <div>
                <p>
                  Organisation Email
                  <span class="text-xs text-expo_red">* </span>
                  <span class="text-truegray-500 text-xs italic">required</span>
                </p>
                <input
                  id="orgEmail"
                  v-model="organisation.email"
                  :class="
                    organisation.validation_error.includes('email')
                      ? 'border-red-300 text-red-600'
                      : 'border-truegray-300'
                  "
                  class="placeholder-truegray-300 focus:border-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600 flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary focus:placeholder-truegray-300 rounded-lg relative bg-white border mb-4"
                  name="orgEmail"
                  type="email"
                  autocomplete="off"
                />
              </div>
              <div>
                <p>
                  Organisation Website
                  <span class="text-xs text-expo_red">* </span>
                  <span class="text-truegray-500 text-xs italic">required</span>
                </p>
                <input
                  id="orgWebsite"
                  v-model="organisation.website"
                  :class="
                    organisation.validation_error.includes('website')
                      ? 'border-red-300 text-red-600'
                      : 'border-truegray-300'
                  "
                  class="placeholder-truegray-300 focus:border-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600 flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary focus:placeholder-truegray-300 rounded-lg relative bg-white border mb-4"
                  name="orgWebsite"
                  type="email"
                  autocomplete="off"
                />
              </div>
              <div>
                <p>
                  Organisation Address
                  <span class="text-xs text-expo_red">* </span>
                  <span class="text-truegray-500 text-xs italic">required</span>
                </p>
                <input
                  id="orgAddress"
                  v-model="organisation.address"
                  class="placeholder-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600 flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary focus:placeholder-truegray-300 rounded-lg relative bg-white border border-truegray-300 mb-4"
                  name="orgAddress"
                  type="text"
                  autocomplete="off"
                />
              </div>
              <div>
                <p>
                  Organisation Sector
                  <span class="text-xs text-expo_red">* </span>
                  <span class="text-truegray-500 text-xs italic">required</span>
                </p>
                <InputDropdown
                  :selected-options-initial="[sector_selected]"
                  :options="sectors"
                  :margin-bottom="false"
                  :shadow-enabled="false"
                  :placeholder-default="'Select one'"
                  :response-selection-id="'new_sector'"
                />
              </div>
              <div>
                <p>
                  Organisation Campus/Office Location(s)
                  <span class="text-xs text-expo_red">* </span>
                  <span class="text-truegray-500 text-xs italic">required</span>
                </p>
                <InputDropdown
                  :selected-options-initial="selected_regions"
                  :options="available_regions"
                  :margin-bottom="false"
                  :shadow-enabled="false"
                  :multiselect="true"
                  :response-selection-id="'update_regions'"
                />
              </div>
            </div>
          </div>

          <!-- Step 4 -->
          <div
            id="step-4"
            :class="
              activeStep === 4
                ? 'translate-x-0'
                : 'pointer-events-none opacity-0 absolute transform -translate-x-full'
            "
            class="inset-0 p-12 2xl:p-24 transition-opacity expo-transition duration-300 ease-in-out delay-100"
          >
            <div class="w-full pb-4 border-b border-truegray-300">
              <h5 class="text-sm m-0 font-black uppercase text-truegray-500">
                Step {{ activeStep }}
              </h5>
              <h4 class="text-expo_dblue">Key Contact Details</h4>
              <h5 class="text-xs m-0 text-truegray-500 italic">
                Please fill out this section with the information for our main
                contact in your organisation
              </h5>
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-x-24 gap-y-4 py-8">
              <div>
                <p>
                  Key Contact Name
                  <span class="text-xs text-expo_red">* </span>
                  <span class="text-truegray-500 text-xs italic">required</span>
                </p>
                <input
                  id="contactName"
                  v-model="contact.name"
                  class="placeholder-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600 flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary focus:placeholder-truegray-300 rounded-lg relative bg-white border border-truegray-300 mb-4"
                  name="contactName"
                  type="text"
                  autocomplete="off"
                />
              </div>
              <div>
                <p>Key Contact Phone</p>
                <input
                  id="contactPhone"
                  v-model="contact.phone"
                  :class="
                    contact.validation_error.includes('phone')
                      ? 'border-red-300 text-red-600'
                      : 'border-truegray-300'
                  "
                  class="placeholder-truegray-300 focus:border-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600 flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary focus:placeholder-truegray-300 rounded-lg relative bg-white border mb-4"
                  name="contactPhone"
                  type="tel"
                  autocomplete="off"
                />
              </div>
              <div>
                <p>
                  Key Contact Mobile
                  <span class="text-xs text-expo_red">* </span>
                  <span class="text-truegray-500 text-xs italic">required</span>
                </p>
                <input
                  id="contactMobile"
                  v-model="contact.mobile"
                  :class="
                    contact.validation_error.includes('mobile')
                      ? 'border-red-300 text-red-600'
                      : 'border-truegray-300'
                  "
                  class="placeholder-truegray-300 focus:border-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600 flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary focus:placeholder-truegray-300 rounded-lg relative bg-white border mb-4"
                  name="contactMobile"
                  type="tel"
                  autocomplete="off"
                />
              </div>
              <div>
                <p>
                  Key Contact Email
                  <span class="text-xs text-expo_red">* </span>
                  <span class="text-truegray-500 text-xs italic">required</span>
                </p>
                <input
                  id="contactEmail"
                  v-model="contact.email"
                  :class="
                    contact.validation_error.includes('email')
                      ? 'border-red-300 text-red-600'
                      : 'border-truegray-300'
                  "
                  class="placeholder-truegray-300 focus:border-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600 flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary focus:placeholder-truegray-300 rounded-lg relative bg-white border mb-4"
                  name="contactEmail"
                  type="email"
                  autocomplete="off"
                />
              </div>
              <div>
                <p>
                  Billing Email
                  <span class="text-truegray-500 text-xs italic"
                    >if different</span
                  >
                </p>
                <input
                  id="contactbillingEmail"
                  v-model="contact.billing_email"
                  :class="
                    contact.validation_error.includes('billing_email')
                      ? 'border-red-300 text-red-600'
                      : 'border-truegray-300'
                  "
                  class="placeholder-truegray-300 focus:border-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600 flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary focus:placeholder-truegray-300 rounded-lg relative bg-white border mb-4"
                  name="contactbillingEmail"
                  type="email"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>

          <!-- Step 5 -->
          <div
            id="step-5"
            :class="
              activeStep === 5
                ? 'translate-x-0'
                : 'pointer-events-none opacity-0 absolute transform -translate-x-full'
            "
            class="inset-0 p-12 2xl:p-24 transition-opacity expo-transition duration-300 ease-in-out delay-100"
          >
            <div class="w-full pb-4 border-b border-truegray-300">
              <h5 class="text-sm m-0 font-black uppercase text-truegray-500">
                Step {{ activeStep }}
              </h5>
              <h4 class="text-expo_dblue">
                Regional Coordinator Details (if applicable)
              </h4>
              <h5 class="text-xs m-0 text-truegray-500 italic">
                These are optional, however please include all contact details
                for any Regional Coordinator you specify.
              </h5>
            </div>

            <div class="flex space-x-4 items-center py-8">
              <p>Do you require seperate regional coordinators?</p>
              <input
                id="coordinatorRequired"
                v-model="coordinatorRequired"
                name="coordinatorRequired"
                type="checkbox"
                class="focus:ring-blue-700 h-4 w-4 text-blue-900 rounded"
              />
            </div>

            <div v-if="coordinatorRequired" class="w-full">
              <div v-if="events.length > 0">
                <div v-for="(event, i) in events" v-if="event.stands" :key="i">
                  <h5 class="text-expo_dblue pt-8 pb-2">
                    {{ event.event_title }}
                  </h5>
                  <div
                    class="grid grid-cols-1 lg:grid-cols-2 gap-x-24 gap-y-4 pb-8"
                  >
                    <div>
                      <p>
                        Coordinator Name
                        <span class="text-xs text-expo_red">* </span>
                        <span class="text-truegray-500 text-xs italic"
                          >required</span
                        >
                      </p>
                      <input
                        :id="'coordinator-' + event.event_id + '-name'"
                        :ref="'coordinator-' + event.event_id + '-name'"
                        v-model="coordinators[i].name"
                        class="placeholder-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600 flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary focus:placeholder-truegray-300 rounded-lg relative bg-white border border-truegray-300 mb-4"
                        :name="'coordinator-' + event.event_id + '-name'"
                        type="text"
                        autocomplete="off"
                      />
                    </div>

                    <div>
                      <p>Coordinator Phone</p>
                      <input
                        :id="'coordinator-' + event.event_id + '-phone'"
                        v-model="coordinators[i].phone"
                        :class="
                          coordinator_phone_error.includes(i)
                            ? 'border-red-300 text-red-600'
                            : 'border-truegray-300'
                        "
                        class="placeholder-truegray-300 focus:border-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600 flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary focus:placeholder-truegray-300 rounded-lg relative bg-white border mb-4"
                        :name="'coordinator-' + event.event_id + '-phone'"
                        type="tel"
                        autocomplete="off"
                      />
                    </div>

                    <div>
                      <p>
                        Coordinator Mobile
                        <span class="text-xs text-expo_red">* </span>
                        <span class="text-truegray-500 text-xs italic"
                          >required</span
                        >
                      </p>
                      <input
                        :id="'coordinator-' + event.event_id + '-mobile'"
                        v-model="coordinators[i].mobile"
                        :class="
                          coordinator_mobile_error.includes(i)
                            ? 'border-red-300 text-red-600'
                            : 'border-truegray-300'
                        "
                        class="placeholder-truegray-300 focus:border-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600 flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary focus:placeholder-truegray-300 rounded-lg relative bg-white border mb-4"
                        :name="'coordinator-' + event.event_id + '-mobile'"
                        type="tel"
                        autocomplete="off"
                      />
                    </div>

                    <div>
                      <p>
                        Coordinator Email
                        <span class="text-xs text-expo_red">* </span>
                        <span class="text-truegray-500 text-xs italic"
                          >required</span
                        >
                      </p>
                      <input
                        :id="'coordinator-' + event.event_id + '-email'"
                        v-model="coordinators[i].email"
                        :class="
                          coordinator_email_error.includes(i)
                            ? 'border-red-300 text-red-600'
                            : 'border-truegray-300'
                        "
                        class="placeholder-truegray-300 focus:border-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600 flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary focus:placeholder-truegray-300 rounded-lg relative bg-white border mb-4"
                        :name="'coordinator-' + event.event_id + '-email'"
                        type="email"
                        autocomplete="off"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Step 6 -->
          <div
            id="step-6"
            :class="
              activeStep === 6
                ? 'translate-x-0'
                : 'pointer-events-none opacity-0 absolute transform -translate-x-full'
            "
            class="inset-0 p-12 2xl:p-24 transition-opacity expo-transition duration-300 ease-in-out delay-100"
          >
            <div class="w-full pb-4 border-b border-truegray-300">
              <h5 class="text-sm m-0 font-black uppercase text-truegray-500">
                Step {{ activeStep }}
              </h5>
              <h4 class="text-expo_dblue">Summary</h4>
              <h5 class="text-xs m-0 text-truegray-500 italic">
                Please ensure all information you have provided is correct
              </h5>
            </div>

            <div class="flex lg:flex-nowrap flex-wrap relative w-full">
              <!-- Summary -->
              <div class="w-full lg:w-1/2 lg:pr-12 mt-12 mb-8 lg:mb-0">
                <div class="flex flex-col space-y-8">
                  <div>
                    <h5 class="pb-4">Organisation</h5>
                    <p
                      v-if="organisation.name && organisation.name.length > 0"
                      class="italic text-sm text-truegray-500"
                    >
                      Name:
                      <span class="ml-4 not-italic text-black">{{
                        organisation.name
                      }}</span>
                    </p>
                    <p
                      v-if="
                        organisation.pref_name &&
                        organisation.pref_name.length > 0
                      "
                      class="italic text-sm text-truegray-500"
                    >
                      Preferred Stand Fascia Name:
                      <span class="ml-4 not-italic text-black">{{
                        organisation.pref_name
                      }}</span>
                    </p>
                    <p
                      v-if="organisation.email && organisation.email.length > 0"
                      class="italic text-sm text-truegray-500"
                    >
                      Email:
                      <span class="ml-4 not-italic text-black">{{
                        organisation.email
                      }}</span>
                    </p>
                    <p
                      v-if="
                        organisation.website && organisation.website.length > 0
                      "
                      class="italic text-sm text-truegray-500"
                    >
                      Website:
                      <span class="ml-4 not-italic text-black">{{
                        organisation.website
                      }}</span>
                    </p>
                    <p
                      v-if="
                        organisation.address && organisation.address.length > 0
                      "
                      class="italic text-sm text-truegray-500"
                    >
                      Address:
                      <span class="ml-4 not-italic text-black">{{
                        organisation.address
                      }}</span>
                    </p>
                    <p
                      v-if="organisation.phone && organisation.phone.length > 0"
                      class="italic text-sm text-truegray-500"
                    >
                      Phone:
                      <span class="ml-4 not-italic text-black">{{
                        organisation.phone
                      }}</span>
                    </p>
                    <p
                      v-if="
                        organisation.sector && organisation.sector.length > 0
                      "
                      class="italic text-sm text-truegray-500"
                    >
                      Sector:
                      <span class="ml-4 not-italic text-black">{{
                        organisation.sector
                      }}</span>
                    </p>
                    <p
                      v-if="
                        organisation.regions && organisation.regions.length > 0
                      "
                      class="italic text-sm text-truegray-500"
                    >
                      <span>Region(s):</span>
                      <span class="space-x-1 space-y-1 w-full py-2">
                        <span
                          v-for="(region, i) in organisation.regions"
                          :key="i"
                          class="text-black rounded-full bg-gray-100 p-1 px-2 text-xs"
                          >{{ region }}</span
                        >
                      </span>
                    </p>
                  </div>

                  <div v-if="proListing">
                    <h5 class="pb-4">Online Expo</h5>
                    <div
                      class="pt text-green-400 flex space-x-4 pt-2 items-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-3 w-3"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"
                        />
                      </svg>
                      <p class="font-bold text-xs">
                        Professional Listing Upgrade
                      </p>
                    </div>
                    <p
                      v-if="proEmail && proEmail.length > 0"
                      class="italic text-sm text-truegray-500"
                    >
                      Profile Login Email
                      <span class="ml-4 not-italic text-black">{{
                        proEmail
                      }}</span>
                    </p>
                  </div>

                  <div>
                    <h5 class="pb-4">Key Contact</h5>
                    <p
                      v-if="contact.name && contact.name.length > 0"
                      class="italic text-sm text-truegray-500"
                    >
                      Name:
                      <span class="ml-4 not-italic text-black">{{
                        contact.name
                      }}</span>
                    </p>
                    <p
                      v-if="contact.phone && contact.phone.length > 0"
                      class="italic text-sm text-truegray-500"
                    >
                      Phone:
                      <span class="ml-4 not-italic text-black">{{
                        contact.phone
                      }}</span>
                    </p>
                    <p
                      v-if="contact.mobile && contact.mobile.length > 0"
                      class="italic text-sm text-truegray-500"
                    >
                      Mobile:
                      <span class="ml-4 not-italic text-black">{{
                        contact.mobile
                      }}</span>
                    </p>
                    <p
                      v-if="contact.email && contact.email.length > 0"
                      class="italic text-sm text-truegray-500"
                    >
                      Email:
                      <span class="ml-4 not-italic text-black">{{
                        contact.email
                      }}</span>
                    </p>
                    <p
                      v-if="
                        contact.billing_email &&
                        contact.billing_email.length > 0
                      "
                      class="italic text-sm text-truegray-500"
                    >
                      Billing Email:
                      <span class="ml-4 not-italic text-black">{{
                        contact.billing_email
                      }}</span>
                    </p>
                  </div>

                  <div>
                    <h5 class="pb-4">Extra comments</h5>
                    <textarea
                      id="comments"
                      v-model="comments"
                      name="comments"
                      rows="2"
                      class="flex-grow p-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full font-primary text-black focus:placeholder-truegray-300 rounded-lg relative bg-white border border-truegray-300 mb-4 placeholder-truegray-300 text-gray-600 focus:text-gray-600 visited:text-gray-600 focus:ring-gray-600"
                    ></textarea>
                  </div>

                  <div v-if="coordinatorRequired && events.length > 0">
                    <h5 class="pb-4">Regional Coordinators</h5>

                    <div v-for="(event, i) in events" :key="i">
                      <!-- If required email field exists, assume we have a coordinator for this region -->
                      <div
                        v-if="event.coordinator.email.length > 0"
                        class="pb-4"
                      >
                        <h5 class="pb-2 text-base">{{ event.event_title }}</h5>
                        <p
                          v-if="event.coordinator.name.length > 0"
                          class="italic text-sm text-truegray-500"
                        >
                          Name:
                          <span class="ml-4 not-italic text-black">{{
                            event.coordinator.name
                          }}</span>
                        </p>
                        <p
                          v-if="event.coordinator.email.length > 0"
                          class="italic text-sm text-truegray-500"
                        >
                          Email:
                          <span class="ml-4 not-italic text-black">{{
                            event.coordinator.email
                          }}</span>
                        </p>
                        <p
                          v-if="event.coordinator.phone.length > 0"
                          class="italic text-sm text-truegray-500"
                        >
                          Phone:
                          <span class="ml-4 not-italic text-black">{{
                            event.coordinator.phone
                          }}</span>
                        </p>
                        <p
                          v-if="event.coordinator.mobile.length > 0"
                          class="italic text-sm text-truegray-500"
                        >
                          Mobile:
                          <span class="ml-4 not-italic text-black">{{
                            event.coordinator.mobile
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Calculator -->
              <div
                class="w-full lg:w-1/2 lg:sticky lg:top-0 lg:-left-0 lg:my-12"
                :style="{ height: 'max-content' }"
              >
                <div class="p-8 max-w-lg rounded-xl bg-truegray-100">
                  <!-- Stands -->
                  <h5 v-if="totalStands > 0" class="text-base">Stands</h5>
                  <div
                    v-if="totalStands > 0"
                    class="border-b border-truegray-300 pb-2"
                  >
                    <div
                      v-for="(event, i) in events"
                      v-if="event.stands"
                      :key="i"
                      class="flex justify-between items-center pt-2"
                    >
                      <p class="italic">
                        {{ event.event_title }} (x<span>{{ event.stands }}</span
                        >)
                      </p>
                      <p>${{ event.cost }}</p>
                    </div>
                  </div>

                  <div class="flex justify-between items-center pt-2">
                    <h5>Stand Total</h5>
                    <h5>${{ totalStands }}</h5>
                  </div>
                  <!-- Leaving retired 5% discount in incase of re-introduction -->
                  <!--
                    <div v-if="locationsBooked >= 3" class="pt text-green-400 flex space-x-4 pt-2 items-center justify-end">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                    </svg>
                    <p class="font-bold text-xs">${{totalStandsDiscount}} stand discount applied!</p>
                    </div> 
                  -->

                  <!-- Online -->
                  <h5 v-if="totalOnline > 0" class="text-base mt-8">
                    Online Expo
                  </h5>
                  <div
                    v-if="totalOnline > 0"
                    class="border-b border-truegray-300 pb-2"
                  >
                    <div
                      v-if="proListing"
                      class="flex justify-between items-center"
                    >
                      <p class="italic">Professional Listing</p>
                      <p>${{ totalOnline }}</p>
                    </div>
                  </div>

                  <div class="flex justify-between items-center pt-2">
                    <h5>Online Total</h5>
                    <h5>${{ totalOnline }}</h5>
                  </div>
                  <div
                    v-if="locationsBooked > 0 && proListing"
                    class="pt text-green-400 flex space-x-4 pt-2 items-center justify-end"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3 w-3"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    <p class="font-bold text-xs">
                      ${{ discountOnline }} exhibitor discount applied!
                    </p>
                  </div>

                  <!-- Totals -->
                  <div
                    class="flex justify-between items-center py-2 border-b border-truegray-300 mt-8"
                  >
                    <p class="text-base">Subtotal</p>
                    <p class="text-base">${{ totalSubtotal }}</p>
                  </div>

                  <div
                    class="flex justify-between items-center py-2 border-b border-truegray-300"
                  >
                    <p class="text-base">GST</p>
                    <p class="text-base">${{ totalGST }}</p>
                  </div>

                  <div class="flex justify-between items-center pt-2">
                    <h5>Total</h5>
                    <h5>${{ totalGrandTotal }}</h5>
                  </div>
                </div>
              </div>
            </div>

            <div class="w-full relative z-40">
              <div class="w-full flex flex-wrap lg:flex-nowrap space-x-4 py-8">
                I have read and accept the
                <span class="ml-2 text-expo_red" @click="toggletermsmodal"
                  >Terms &amp; Conditions</span
                >
                <input
                  id="terms"
                  name="terms"
                  type="checkbox"
                  class="focus:ring-blue-700 h-4 w-4 text-blue-900 rounded"
                  @click="toggleterms"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Form base -->
        <div class="relative pt-6">
          <div class="flex space-x-12 w-full justify-center">
            <button
              :class="
                activeStep > 1 ? 'opacity-100' : 'opacity-0 pointer-events-none'
              "
              class="btn btn-trans-black h-8"
              @click="changeStep('-')"
            >
              Previous
            </button>
            <button
              v-if="activeStep !== 6"
              :class="activeStep < 6 ? 'opacity-100' : 'opacity-0'"
              class="btn btn-expo-red h-8"
              @click="changeStep('+')"
            >
              Next
            </button>
            <button
              v-if="activeStep === 6 && !registrationSuccess"
              :disabled="!terms"
              :class="[terms ? '' : 'opacity-25 cursor-not-allowed']"
              class="btn btn-expo-red h-8 relative"
              @click="submitForm()"
            >
              <div
                class="absolute inset-0 w-full flex justify-center items-center z-20"
              >
                <lottie v-if="thinking" :options="loadingAnimationOptions" />
              </div>
              <span :class="[thinking ? 'invisible' : '']">Submit</span>
            </button>
          </div>
        </div>

        <!-- progress % bar -->
        <div
          class="w-full flex justify-center mt-8 rounded-b-xl overflow-hidden"
        >
          <div class="progress bg-truegray-300 relative w-full h-8">
            <div
              :style="{ width: progress + '%' }"
              :class="
                activeStep > 1 || progress > 0 ? 'opacity-100' : 'opacity-0'
              "
              class="progress-done text-white flex items-center justify-center h-full"
            >
              {{ progress }}%
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Video Modal -->
    <div
      v-show="videoModal"
      id="videoModal"
      class="fixed z-50 inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
        ></div>
        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >
        <!-- Modal panel, show/hide based on modal state. -->
        <div
          style="height: calc(100vh - 10rem)"
          :class="videoModal ? '' : 'p-8 w-52 h-52'"
          class="bg-cover inline-block align-bottom bg-white border-8 border-white rounded-4xl p-6 text-left shadow transform transition-all duration-300 ease-in-out sm:my-8 sm:align-middle sm:max-w-4xl sm:max-h-lg sm:w-full sm:p-16 relative"
        >
          <div
            class="flex flex-col bg-black absolute bg-center inset-0 w-full h-full rounded-4xl overflow-hidden z-10 bg-no-repeat"
          >
            <iframe
              v-if="videoModal"
              ref="resourceVideoPreview"
              type="iframe"
              class="object-fill w-full h-full"
              :src="videoSrc"
              frameborder="0"
              controls="0"
              pip="0"
              title="1"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              autoplay
            ></iframe>
          </div>
          <div class="flex flex-col space-y-4">
            <button
              type="button"
              class="absolute z-40 right-16 top-12 transform hover:rotate-180 transition-all duration-300 text-white hover:text-expo_red"
              @click="videoModal = false"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { shared } from '../../../js/mixins/shared.js'
import { EventBus } from '../../../js/plugins/event-bus.js'
import InputDropdown from '../../../shared/components/InputDropdown.vue'
import * as loadingAnimation from '../../../shared/components/loading.json'

export default {
  components: {
    InputDropdown,
  },

  mixins: [shared],

  data() {
    return {
      videoModal: false,
      videoSrc: 'https://www.youtube.com/embed/5oEw5jUb1FU',

      loaded: false,
      thinking: false,
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      loadingAnimate: false,

      activeStep: 1,
      activeStepIncompleteMessage: 'Please fill in required fields',
      stepsCompleted: 0,

      progress: 0, //percentage

      //Calculation data
      costOnline: 1995,
      costDiscountedOnline: 0, //discounted cost for pro exhibitor step 2 UI

      discountOnline: 1296,
      discountStand: 0.05, //percentage
      GST: 0.15, //percentage
      locationsBooked: 0,

      // Total costs
      totalStands: 0,
      totalStandsDiscount: 0,
      totalOnline: 0,

      totalSubtotal: 0,
      totalGST: 0,
      totalGrandTotal: 0,
      totals: {},

      // Step 1
      stands: [],
      events: [],

      // Step 2
      listingOptOut: false,
      proListing: true,
      proEmail: null,
      proEmailValidationError: false,

      // Step 3
      organisation: {
        name: null,
        website: null,
        pref_name: null,
        address: null,
        phone: null,
        email: null,
        sector: null,
        regions: [],
        // Highlight any fields that have validation errors!
        validation_error: [],
      },

      available_regions: [],
      selected_regions: [],

      sectors: [
        { text: 'Creative Industries', value: 1 },
        { text: 'Social & Community', value: 2 },
        { text: 'Manufacturing & Technology', value: 3 },
        { text: 'Service Industries', value: 4 },
        { text: 'Construction & Infrastructure', value: 5 },
        { text: 'Tertiary', value: 6 },
        { text: 'Other', value: 7 },
      ],

      sector_selected: null,

      // Step 4
      contact: {
        name: '',
        phone: '',
        mobile: '',
        email: '',
        billing_email: '',
        // Highlight any fields that have validation errors!
        validation_error: [],
      },

      // Step 5
      coordinatorRequired: false,
      coordinatorStepCompleted: true,
      coordinator_name_error: [],
      coordinator_email_error: [],
      coordinator_phone_error: [],
      coordinator_mobile_error: [],
      coordinators: [
        {
          name: [],
          email: [],
          phone: [],
          mobile: [],
        },
        {
          name: [],
          email: [],
          phone: [],
          mobile: [],
        },
        {
          name: [],
          email: [],
          phone: [],
          mobile: [],
        },
        {
          name: [],
          email: [],
          phone: [],
          mobile: [],
        },
        {
          name: [],
          email: [],
          phone: [],
          mobile: [],
        },
        {
          name: [],
          email: [],
          phone: [],
          mobile: [],
        },
        {
          name: [],
          email: [],
          phone: [],
          mobile: [],
        },
        {
          name: [],
          email: [],
          phone: [],
          mobile: [],
        },
        {
          name: [],
          email: [],
          phone: [],
          mobile: [],
        },
        {
          name: [],
          email: [],
          phone: [],
          mobile: [],
        },
      ],

      // Step 6
      comments: null,
      terms: false,
      inputData: [],

      registrationSuccess: false,
    }
  },

  computed: {
    // Set all map getters
    ...mapGetters({
      settings: 'shared/getSettings',
      storeEvents: 'expo/getEvents',
    }),
  },

  watch: {
    'videoModal': {
      handler: function (val) {
        this.setBodyLockModal(val ? true : false) // Add to all modals to lock the background scroll.
      },

      deep: true,
    },

    'listingOptOut': {
      handler: function (val) {
        this.$set(this, 'proListing', !val)
      },

      deep: true,
    },

    'coordinators': {
      handler: function (obj) {
        let index = 0
        this.events.forEach(() => {
          // let phone = obj[index].phone;
          // if (phone.length < 1) {
          //     for( var i = 0; i < this.coordinator_phone_error.length; i++){
          //         if (this.coordinator_phone_error[i] === index) { this.coordinator_phone_error.splice(i,1); } // Remove this from the update
          //     }
          // } else {
          //     if (!this.validatePhoneNumber(phone)) {
          //         if (!this.coordinator_phone_error.includes(index)) this.coordinator_phone_error.push(index);
          //     } else {
          //         for( var i = 0; i < this.coordinator_phone_error.length; i++){
          //             if (this.coordinator_phone_error[i] === index) { this.coordinator_phone_error.splice(i,1); } // Remove this from the update
          //         }
          //     }
          // }

          let mobile = obj[index].mobile
          if (mobile.length < 1) {
            for (let i = 0; i < this.coordinator_mobile_error.length; i++) {
              if (this.coordinator_mobile_error[i] === index) {
                this.coordinator_mobile_error.splice(i, 1)
              } // Remove this from the update
            }
          } else {
            if (mobile.length < 7) {
              if (!this.coordinator_mobile_error.includes(index)) {
                this.coordinator_mobile_error.push(index)
              }
            } else {
              for (let j = 0; j < this.coordinator_mobile_error.length; j++) {
                if (this.coordinator_mobile_error[j] === index) {
                  this.coordinator_mobile_error.splice(j, 1)
                } // Remove this from the update
              }
            }
          }

          let email = obj[index].email
          if (email.length < 1) {
            for (let k = 0; k < this.coordinator_email_error.length; k++) {
              if (this.coordinator_email_error[k] === index) {
                this.coordinator_email_error.splice(k, 1)
              } // Remove this from the update
            }
          } else {
            if (!this.validateEmail(email)) {
              if (!this.coordinator_email_error.includes(index)) {
                this.coordinator_email_error.push(index)
              }
            } else {
              for (let l = 0; l < this.coordinator_email_error.length; l++) {
                if (this.coordinator_email_error[l] === index) {
                  this.coordinator_email_error.splice(l, 1)
                } // Remove this from the update
              }
            }
          }

          index = index + 1
        })
      },

      deep: true,
    },

    'events': {
      handler: function (events) {
        let num = 0
        events.forEach(() => {
          if (!this.coordinators[num]) {
            this.coordinators[num] = {
              name: null,
              email: null,
              phone: null,
              mobile: null,
            }
          }
          num = num + 1
        })
      },

      deep: true,
    },

    'coordinatorRequired': {
      handler: function () {
        this.updateCoordinators()
      },

      deep: true,
    },

    'selected_regions': {
      handler: function (arr) {
        let arrTitles = []
        this.available_regions.forEach((i) => {
          if (arr.includes(i.value)) {
            arrTitles.push(i.text)
          }
        })
        this.$set(this.organisation, 'regions', arrTitles)
      },

      deep: true,
    },

    // Step 2 - online
    'proListing': {
      handler: function (val) {
        if (!val) {
          this.$set(this, 'proEmail', null) // Clear the email if pro listing is un-checked.
        }
        this.calcOnlineTotal()
      },

      deep: true,
    },

    'proEmail': {
      handler: function (email) {
        if (!this.proListing) {
          this.$set(this, 'proEmailValidationError', false)
          return
        }

        // Check that this value is a valid email...
        if (!this.validateEmail(email)) {
          this.$set(this, 'proEmailValidationError', true)
        } else {
          this.$set(this, 'proEmailValidationError', false)
        }
      },

      deep: true,
    },

    // Step 3 - organisation details
    'organisation': {
      handler: function (data) {
        let inputData = true

        if (
          !data.name ||
          !data.website ||
          !data.address ||
          !data.phone ||
          !data.email ||
          !data.sector ||
          !data.regions
        ) {
          inputData = false
        }

        // Specific validation for these :
        if (data.regions) {
          // At least one val in arr
          if (data.regions.length < 1) {
            inputData = false
          }
        }
        if (data.email) {
          // validate email string
          if (!this.validateEmail(data.email)) {
            inputData = false
          }
        }
        // if (data.phone) { // A valid phone number
        //     if (this.validatePhoneNumber(data.phone)) inputData = false;
        // }

        if (data.sector) {
          // A valid phone number
          if (!this.sector_selected) {
            inputData = false
          }
        }

        if (inputData && !this.inputData.includes('organisation')) {
          this.inputData.push('organisation')
        } else {
          for (let i = 0; i < this.inputData.length; i++) {
            if (this.inputData[i] === 'organisation') {
              this.inputData.splice(i, 1)
            } // Remove this from the update
          }
        }
      },

      deep: true,
    },

    'organisation.email': {
      handler: function (email) {
        if (email.length === '') {
          for (let i = 0; i < this.organisation.validation_error.length; i++) {
            if (this.organisation.validation_error[i] === 'email') {
              this.organisation.validation_error.splice(i, 1)
            } // Remove this from the update
          }
          return
        }

        if (!this.validateEmail(email)) {
          if (!this.organisation.validation_error.includes('email')) {
            this.organisation.validation_error.push('email')
          }
        } else {
          for (let j = 0; j < this.organisation.validation_error.length; j++) {
            if (this.organisation.validation_error[j] === 'email') {
              this.organisation.validation_error.splice(j, 1)
            } // Remove this from the update
          }
        }
      },

      deep: true,
    },

    // 'organisation.phone': {
    //   handler: function (phone) {
    //     // if (phone.length === '') {
    //     //     for( var i = 0; i < this.organisation.validation_error.length; i++){
    //     //         if (this.organisation.validation_error[i] === 'phone') { this.organisation.validation_error.splice(i,1); } // Remove this from the update
    //     //     }
    //     //     return;
    //     // }
    //     // if (!this.validatePhoneNumber(phone)) {
    //     //     if (!this.organisation.validation_error.includes('phone')) this.organisation.validation_error.push('phone');
    //     // } else {
    //     //     for( var i = 0; i < this.organisation.validation_error.length; i++){
    //     //         if (this.organisation.validation_error[i] === 'phone') { this.organisation.validation_error.splice(i,1); } // Remove this from the update
    //     //     }
    //     // }
    //   },
    //   deep: true,
    // },

    'organisation.website': {
      handler: function (website) {
        if (website.length === '') {
          for (let i = 0; i < this.organisation.validation_error.length; i++) {
            if (this.organisation.validation_error[i] === 'website') {
              this.organisation.validation_error.splice(i, 1)
            } // Remove this from the update
          }
          return
        }

        if (!this.validateURL(website)) {
          if (!this.organisation.validation_error.includes('website')) {
            this.organisation.validation_error.push('website')
          }
        } else {
          for (let j = 0; j < this.organisation.validation_error.length; j++) {
            if (this.organisation.validation_error[j] === 'website') {
              this.organisation.validation_error.splice(j, 1)
            } // Remove this from the update
          }
        }
      },

      deep: true,
    },

    'sector_selected': {
      handler: function () {
        const sector = this.sectors.find(
          (sector) => sector.value === this.sector_selected,
        )
        this.$set(this.organisation, 'sector', sector?.text || null)
      },

      deep: true,
    },

    'contact': {
      handler: function (data) {
        let inputData = true

        if (
          !data.name ||
          !data.phone ||
          !data.email ||
          !data.billing_email ||
          !data.mobile
        ) {
          inputData = false
        }

        // Specific validation for these :
        if (data.email) {
          // validate email string
          if (!this.validateEmail(data.email)) {
            inputData = false
          }
        }
        if (data.billing_email) {
          // validate email string
          if (!this.validateEmail(data.billing_email)) {
            inputData = false
          }
        }
        // if (data.phone) { // A valid phone number
        //     if (this.validatePhoneNumber(data.phone)) inputData = false;
        // }
        // if (data.mobile) { // A valid phone number
        //     if (this.validatePhoneNumber(data.mobile)) inputData = false;
        // }

        if (inputData && !this.inputData.includes('contact')) {
          this.inputData.push('contact')
        } else {
          for (let i = 0; i < this.inputData.length; i++) {
            if (this.inputData[i] === 'contact') {
              this.inputData.splice(i, 1)
            } // Remove this from the update
          }
        }
      },

      deep: true,
    },

    // Step 4 - key contact
    // 'contact.phone': {
    //   handler: function (val) {
    //     // let key = 'phone';
    //     // if (val.length === '') {
    //     //     for( var i = 0; i < this.contact.validation_error.length; i++){
    //     //         if (this.contact.validation_error[i] === key) { this.contact.validation_error.splice(i,1); } // Remove this from the update
    //     //     }
    //     //     return;
    //     // }
    //     // if (!this.validatePhoneNumber(val)) {
    //     //     if (!this.contact.validation_error.includes(key)) this.contact.validation_error.push(key);
    //     // } else {
    //     //     for( var i = 0; i < this.contact.validation_error.length; i++){
    //     //         if (this.contact.validation_error[i] === key) { this.contact.validation_error.splice(i,1); } // Remove this from the update
    //     //     }
    //     // }
    //   },
    //   deep: true,
    // },

    'contact.mobile': {
      handler: function (val) {
        let key = 'mobile'
        if (val.length === '') {
          for (let i = 0; i < this.contact.validation_error.length; i++) {
            if (this.contact.validation_error[i] === key) {
              this.contact.validation_error.splice(i, 1)
            } // Remove this from the update
          }
          return
        }
        if (val.length < 7) {
          if (!this.contact.validation_error.includes(key)) {
            this.contact.validation_error.push(key)
          }
        } else {
          for (let j = 0; j < this.contact.validation_error.length; j++) {
            if (this.contact.validation_error[j] === key) {
              this.contact.validation_error.splice(j, 1)
            } // Remove this from the update
          }
        }
      },

      deep: true,
    },

    'contact.email': {
      handler: function (val) {
        let key = 'email'
        if (val.length === '') {
          for (let i = 0; i < this.contact.validation_error.length; i++) {
            if (this.contact.validation_error[i] === key) {
              this.contact.validation_error.splice(i, 1)
            } // Remove this from the update
          }
          return
        }
        if (!this.validateEmail(val)) {
          if (!this.contact.validation_error.includes(key)) {
            this.contact.validation_error.push(key)
          }
        } else {
          for (let j = 0; j < this.contact.validation_error.length; j++) {
            if (this.contact.validation_error[j] === key) {
              this.contact.validation_error.splice(j, 1)
            } // Remove this from the update
          }
        }
      },

      deep: true,
    },

    'contact.billing_email': {
      handler: function (val) {
        let key = 'billing_email'
        if (val.length === '') {
          for (let i = 0; i < this.contact.validation_error.length; i++) {
            if (this.contact.validation_error[i] === key) {
              this.contact.validation_error.splice(i, 1)
            } // Remove this from the update
          }
          return
        }
        if (!this.validateEmail(val)) {
          if (!this.contact.validation_error.includes(key)) {
            this.contact.validation_error.push(key)
          }
        } else {
          for (let j = 0; j < this.contact.validation_error.length; j++) {
            if (this.contact.validation_error[j] === key) {
              this.contact.validation_error.splice(j, 1)
            } // Remove this from the update
          }
        }
      },

      deep: true,
    },

    // Step 6
    'terms': {
      handler: function () {
        this.inputData.push('terms')
      },

      deep: true,
    },

    'comments': {
      handler: function () {
        this.inputData.push('comments')
      },

      deep: true,
    },

    'storeEvents': {
      handler: function (val) {
        let arr = []
        val.forEach(() => {
          arr.push(0)
        })
        this.$set(this, 'stands', arr)
      },

      deep: true,
    },
  },

  async mounted() {
    // const d = new Date()
    // let year = d.getFullYear();
    // this.$set(this, 'year', year);

    this.$set(
      this,
      'costDiscountedOnline',
      this.costOnline - this.discountOnline,
    )

    // Sectors :
    EventBus.$on('new_sector', (selected) => {
      if (selected < 1) {
        return
      }
      this.$set(this, 'sector_selected', selected)
    })

    // Regions :
    if (this.settings.regions) {
      let arr = []
      this.settings.regions.forEach((i) => {
        arr.push(i)
      })
      this.$set(this, 'available_regions', arr)
    }
    EventBus.$on('update_regions', (arr) => {
      this.$set(this, 'selected_regions', arr)
    })

    if (this.storeEvents.length < 1) {
      await this.dispatchSetEvents()
      // @todo test/fix/remove
      setTimeout(() => {
        this.$set(this, 'loaded', true)
      }, 100)
    } else {
      this.$set(this, 'loaded', true)
      this.$set(this, 'events', this.storeEvents)
    }
  },

  methods: {
    ...mapActions({
      dispatchSetEvents: 'expo/dispatchSetEvents',
    }),

    toggleterms() {
      if (this.terms) {
        this.$set(this, 'terms', false)
      } else {
        this.$set(this, 'terms', true)
      }
    },

    toggletermsmodal() {
      EventBus.$emit('showModal', 'exhibitor-terms')
    },

    updateStands(event, i) {
      let value = this.stands[i]

      let exists = false
      this.events.forEach((i) => {
        if (i.event_id === event.id) {
          exists = true
        }
      })
      let array = []

      if (exists) {
        this.events.forEach((i) => {
          if (i.event_id === event.id) {
            if (value === 0) {
              let newArr = this.events.filter(function (obj) {
                return obj.id !== i.event_id
              })
              this.$set(this, 'events', newArr) // remove event from array if no stands
              return
            }
            i.stands = value
            i.cost = value * event.cost_per_stand
          }
          array.push(i)
        })
      } else {
        let obj = {}

        obj.stands = value
        obj.event_title = event.title
        obj.event_id = event.id
        obj.cost = value * event.cost_per_stand

        array.push(obj)
        this.events.forEach((i) => {
          array.push(i)
        })
        if (!this.inputData.includes('events')) {
          this.inputData.push('events')
        }
      }

      this.$set(this, 'events', array)
      this.calcTotalLocations()
    },

    updateCoordinators() {
      if (this.coordinatorRequired) {
        this.events.forEach((i) => {
          i.coordinator = {
            name: '',
            email: '',
            phone: '',
            mobile: '',
          }
        })
      } else {
        this.events.forEach((i) => {
          delete i.coordinator
        })
      }
    },

    changeStep(direction) {
      // Allow previous step transitions without checkIfStepIsCompleted!
      if (direction === '-') {
        let step = this.activeStep - 1
        this.$set(this, 'activeStep', step)
        setTimeout(() => {
          this.$scrollTo('#formTop')
        }, 100)
        return
      }

      this.calcTotalLocations()
      this.calcOnlineTotal()

      // check if current step has been completed correctly!
      let canProceed = this.checkIfStepIsCompleted()

      if (!canProceed) {
        EventBus.$emit('triggerAlertResponse', {
          status: 'error',
          message: this.activeStepIncompleteMessage,
        })
        return
      } else {
        let step = this.activeStep + 1
        let progresspoint = 0

        switch (step) {
          case 2:
            progresspoint = 20
            break
          case 3:
            progresspoint = 40
            break
          case 4:
            progresspoint = 60
            break
          case 5:
            progresspoint = 80
            break
          case 6:
            progresspoint = 100
            break
          default:
            break
        }

        this.$set(this, 'progress', progresspoint)
        this.$set(this, 'activeStep', step)

        setTimeout(() => {
          this.$scrollTo('#formTop')
        }, 100)

        this.calcTotalLocations()
        this.calcTotalCosts()
      }
    },

    checkIfStepIsCompleted() {
      let canProceed = true

      // Validate required fields in each section
      switch (this.activeStep) {
        case 1:
          // Nothing is required in this step to proceed.
          return true

        case 2:
          if (!this.proListing) {
            canProceed = true
          } else {
            if (!this.proEmail) {
              canProceed = false
            } else {
              // If a pro listing is checked && the email field is not supplied or is in valid email then do not proceed.
              this.$set(
                this,
                'activeStepIncompleteMessage',
                'Please provide a valid email',
              )
              if (this.proEmailValidationError) {
                canProceed = false
              }
            }
          }

          return canProceed

        case 3:
          // Org - required: Name, Address, Email, Sector, Locations
          ;[
            'orgName',
            'orgAddress',
            'orgEmail',
            'orgSector',
            'orgRegions',
          ].forEach((i) => {
            let val = this.returnDataNodeValue(i)
            if (i === 'orgSector' && !this.sector_selected) {
              canProceed = false
            } else {
              if (val === null || val.length < 1) {
                this.$set(
                  this,
                  'activeStepIncompleteMessage',
                  'Please fill in required fields',
                )
                canProceed = false
              }
            }
          })

          // All mandatory fields have been added are there validation errors ???
          if (
            this.organisation.validation_error.includes('email') ||
            this.organisation.validation_error.includes('phone') ||
            this.organisation.validation_error.includes('website')
          ) {
            this.$set(
              this,
              'activeStepIncompleteMessage',
              'You have validation errors',
            )
            canProceed = false
          }

          return canProceed

        case 4:
          // Contact - required: contactName, contactEmail, contactMobile
          ;['contactName', 'contactEmail', 'contactMobile'].forEach((i) => {
            let val = this.returnDataNodeValue(i)
            if (val === null || val.length < 1) {
              this.$set(
                this,
                'activeStepIncompleteMessage',
                'Please fill in required fields',
              )
              canProceed = false
            }
          })

          // All mandatory fields have been added are there validation errors ???
          if (
            this.contact.validation_error.includes('email') ||
            this.contact.validation_error.includes('billing_email') ||
            this.contact.validation_error.includes('phone') ||
            this.contact.validation_error.includes('mobile')
          ) {
            this.$set(
              this,
              'activeStepIncompleteMessage',
              'You have validation errors',
            )
            canProceed = false
          }

          return canProceed

        case 5:
          // If events and coordinator is checked then we need to validate that all coordinator information has been provided and validated...
          if (this.events.length > 0) {
            canProceed = true

            let index = 0
            let requiredFieldsCompletd = true
            this.events.forEach(() => {
              if (
                this.coordinators[index].name.length < 0 ||
                this.coordinators[index].mobile.length < 0 ||
                this.coordinators[index].email.length < 0
              ) {
                requiredFieldsCompletd = false
              }
            })
            if (!requiredFieldsCompletd) {
              this.$set(
                this,
                'activeStepIncompleteMessage',
                'Please fill in required fields',
              )
            }

            index = 0
            let validationFieldsClear = true
            this.events.forEach(() => {
              if (this.coordinator_phone_error.includes(index)) {
                validationFieldsClear = false
              }
              if (this.coordinator_mobile_error.includes(index)) {
                validationFieldsClear = false
              }
              if (this.coordinator_email_error.includes(index)) {
                validationFieldsClear = false
              }
            })
            if (!validationFieldsClear) {
              this.$set(
                this,
                'activeStepIncompleteMessage',
                'You have validation errors',
              )
            }

            if (!validationFieldsClear || !requiredFieldsCompletd) {
              canProceed = false
            }
          } else {
            canProceed = true
          }

          if (canProceed) {
            // Send all coordinators to events
            let index = 0
            this.events.forEach(() => {
              let coordinator = {
                name: this.coordinators[index].name,
                email: this.coordinators[index].email,
                phone: this.coordinators[index].phone,
                mobile: this.coordinators[index].mobile,
              }
              this.events[index].coordinator = coordinator
              index = index + 1
            })
          }

          return canProceed

        case 6:
          // Summary - required: t's & c's
          if (this.terms) {
            canProceed = false
          }

          return canProceed

        default:
          break
      }
    },

    returnDataNodeValue(key) {
      let value = null
      switch (key) {
        // // Step 1
        case 'events':
          value = this.events
          break

        // Step 2
        case 'proListing':
          value = this.proListing
          break
        case 'proEmail':
          value = this.proEmail
          break

        // Step 3

        case 'orgName':
          value = this.organisation.name
          break
        case 'orgAddress':
          value = this.organisation.address
          break
        case 'orgEmail':
          value = this.organisation.email
          break
        case 'orgSector':
          value = this.organisation.sector
          break
        case 'orgRegions':
          value = this.organisation.regions
          break
        case 'orgWebsite':
          value = this.organisation.website
          break
        case 'orgPrefName':
          value = this.organisation.pref_name
          break
        case 'orgPhone':
          value = this.organisation.phone
          break
        case 'organisation':
          value = this.organisation
          break

        // Step 4
        case 'contactName':
          value = this.contact.name
          break
        case 'contactEmail':
          value = this.contact.email
          break
        case 'contactMobile':
          value = this.contact.mobile
          break
        case 'contactPhone':
          value = this.contact.phone
          break
        case 'contactbillingEmail':
          value = this.contact.billing_email
          break
        case 'contact':
          value = this.contact
          break

        // Step 6
        case 'terms':
          value = this.terms
          break
        case 'comments':
          value = this.comments
          break

        default:
          break
      }
      return value
    },

    calcTotalLocations() {
      let locationsBooked = 0
      this.events.forEach((i) => {
        if (i.stands && i.stands > 0) {
          locationsBooked = locationsBooked + 1
        }
      })
      this.$set(this, 'locationsBooked', locationsBooked)
    },

    calcOnlineTotal() {
      if (!this.proListing) {
        this.$set(this, 'totalOnline', 0)
      } else if (this.locationsBooked > 0) {
        this.$set(
          this,
          'totalOnline',
          parseInt(this.costOnline - this.discountOnline),
        )
      } else {
        this.$set(this, 'totalOnline', this.costOnline)
      }
    },

    calcTotalCosts() {
      // Stand subtotal
      let standSubtotal = 0

      this.events.forEach((i) => {
        if (i.stands) {
          standSubtotal = Number(standSubtotal) + Number(i.cost)
        }
      })

      // Leaving retired discount in incase of re-introduction
      // if (this.locationsBooked >= 3) {
      //     this.$set(this, 'totalStandsDiscount', Math.round(((standSubtotal * this.discountStand) + Number.EPSILON) * 100) / 100); //rounded to 2 decimal places;
      // };

      let standTotal = standSubtotal - this.totalStandsDiscount

      this.$set(this, 'totalStands', standTotal)
      this.$set(this, 'totalSubtotal', this.totalStands + this.totalOnline)
      this.$set(
        this,
        'totalGST',
        Math.round((this.totalSubtotal * this.GST + Number.EPSILON) * 100) /
          100,
      ) //rounded to 2 decimal places
      this.$set(this, 'totalGrandTotal', this.totalSubtotal + this.totalGST)
      let totalsObj = {
        standsCost: standSubtotal,
        standsDiscount: this.totalStandsDiscount,
        standsTotal: standTotal,
        onlineTotal: this.totalOnline,
        subtotal: this.totalSubtotal,
        GST: this.totalGST,
        grandTotal: this.totalGrandTotal,
      }
      this.$set(this, 'totals', totalsObj)
    },

    submitForm() {
      let submitData = {
        category: 0, // 1 = school, 0 = exhibitor
        totalStands: this.totalStands,
        totalStandsDiscount: this.totalStandsDiscount,
        totalOnline: this.totalOnline,
        totalSubtotal: this.totalOntotalSubtotalline,
        totalGST: this.totalGST,
        totalGrandTotal: this.totalGrandTotal,
        comments: this.comments,
        organisation: this.organisation,
        events: this.events,
        contact: this.contact,
        sector: this.sector,
        pro: this.proListing,
        pro_email: this.proEmail,
        terms: this.terms,
      }

      this.$set(this, 'thinking', true)

      axios.post('/api/expo-registration', submitData).then((response) => {
        if (response.data.success) {
          this.$set(this, 'inputData', [])
          this.$set(this, 'thinking', false)
          this.$set(this, 'registrationSuccess', true)
        } else {
          //...
          this.$set(this, 'thinking', false)
        }
        if (response.data.alert) {
          EventBus.$emit('triggerAlertResponse', response.data.alert)
        }
      })
    },
  },
}
</script>

<style scoped>
.onlineanimate {
  background-position: top center;
  animation: onlineanimate 8s infinite ease-in-out;
}
@keyframes onlineanimate {
  50% {
    background-position: bottom center;
  }
}
.expo-transition {
  transition: opacity 0.3s ease-in-out 0.1s;
}

.progress-done {
  width: 0;
  background: linear-gradient(to left, #fea4a3, #fe4a49);
  transition: width ease 0.3s;
  transition-property: width, opacity;
}

.form-header_curve {
  border-bottom-left-radius: 100% 200px;
  border-bottom-right-radius: 100% 200px;
  height: 100px;
  margin-top: -30px;
  width: 120%;
  position: relative;
  right: 10%;
  z-index: 1;
}

.hero-gradient::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  height: 100%;
  background: rgb(0, 0, 0);
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.804359243697479) 0%,
    rgba(0, 0, 0, 0.5942752100840336) 36%,
    rgba(0, 0, 0, 0) 100%
  );
}

.video-placeholder::before {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  content: '';
  background: linear-gradient(
      223.93deg,
      #fe4a49 8.36%,
      rgba(254, 74, 73, 0.2) 65.47%
    ),
    #05162e;
  z-index: -1;
  opacity: 0.4;
}
</style>
